/*
 * Cozy: float configured "size tab" callouts above their matching Size buttons.
 *
 * The _size-tab child blocks of the variant picker render inert carrier spans
 * (.cozy-size-tab[data-cozy-size-tab-label]) as siblings of <variant-picker>. This script moves
 * each carrier into the Size button whose option value matches its label, and marks that button so
 * CSS can float the tab above the top edge. Matching is by option value (case-insensitive), never
 * by position, so new sizes work automatically. Runs on load and re-runs on DOM changes so tabs
 * survive the variant picker re-rendering (combined-listing morphs). Loaded once from <head> via
 * stylesheets.liquid, so it also upgrades any markup morphed in later.
 */
(function () {
  function norm(v) {
    return (v == null ? '' : String(v)).trim().toLowerCase();
  }

  function placeAll() {
    var pickers = document.querySelectorAll('variant-picker');
    for (var p = 0; p < pickers.length; p++) {
      var vp = pickers[p];
      var scope = vp.closest('[id^="ProductInformation-"]') || vp.parentNode;
      if (!scope) continue;

      var carriers = scope.querySelectorAll('.cozy-size-tab[data-cozy-size-tab-label]');
      if (!carriers.length) continue;

      var labels = vp.querySelectorAll('.variant-option--buttons .variant-option__button-label');
      if (!labels.length) continue;

      for (var c = 0; c < carriers.length; c++) {
        var tab = carriers[c];
        var want = norm(tab.getAttribute('data-cozy-size-tab-label'));
        if (!want) continue;

        for (var i = 0; i < labels.length; i++) {
          var label = labels[i];
          var input = label.querySelector('input[type="radio"]');
          var textEl = label.querySelector('.variant-option__button-label__text');
          var val = input ? norm(input.value) : norm(textEl ? textEl.textContent : '');
          if (val !== want) continue;

          // Already placed in this button: nothing to do (avoids observer feedback loops).
          if (tab.parentNode === label) {
            label.classList.add('cozy-has-tab');
            break;
          }
          // A stale tab already lives here (e.g. after a morph): drop it before re-placing.
          var stale = label.querySelector('.cozy-size-tab');
          if (stale && stale !== tab) stale.parentNode.removeChild(stale);

          label.appendChild(tab);
          label.classList.add('cozy-has-tab');
          break;
        }
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      placeAll();
    }, 60);
  }

  function boot() {
    placeAll();
    if (typeof MutationObserver === 'function') {
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
